'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var keysOf = {};

exports.__exports = keysOf;
